// extracted by mini-css-extract-plugin
module.exports = {"t2mqymg":"t2mqymg","ij09k0n":"ij09k0n"};